import React, {useState} from 'react';
import {
   Image,
   View,
   TextInput,
   TouchableOpacity,
   Dimensions,
   Platform,
} from 'react-native';
import {
   primaryState700,
   primaryColor500,
   FONT_FAMILY_REGULAR,
   isWindows,
   isMacOS,
} from '../../utils/utils';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';

const SearchView = props => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [searchText, setSearchText] = useState('');
   const [isSearchFocused, setIsSearchFocused] = useState(false);
   const imageSize =
      Platform.OS === 'windows' ? 0 : Platform.OS === 'web' ? 10 : 18;
   function onChangeSearchText(text) {
      setSearchText(text);
      props.onSearch(text);
   }
   const searchHandleFocus = () => {
      setIsSearchFocused(true);
   };
   const searchHandleBlur = () => {
      setIsSearchFocused(false);
   };
   const mobRadius = 6;
   return (
      <View
         style={{
            flexDirection: 'row',
            backgroundColor: primaryState700,
            borderRadius: isLandscapemode ? 4 : mobRadius,
            width: !isLandscapemode ? '100%' : null,
            justifyContent: 'space-between',
            alignItems: 'center',
            ...Platform.select({
               web: {
                  borderBottomWidth: 2,
                  height: 40,
                  marginRight: isLandscapemode ? 3 : null,
                  borderBottomColor: isSearchFocused
                     ? primaryColor500
                     : 'transparent',
               },
               windows: {
                  borderBottomWidth: 0,
                  height: 40,
                  borderBottomColor: isSearchFocused
                     ? primaryColor500
                     : 'transparent',
               },
            }),
         }}>
         {/* {searchText.length > 0 && Platform.OS != 'windows' && (
            <TouchableOpacity
               onPress={() => {
                  props.onClearText();
                  setSearchText('');
               }}>
               <Image
                  source={require('../../assets/cross.png')}
                  style={{width: imageSize, height: imageSize, margin: 10}}
               />
            </TouchableOpacity>
         )} */}
         <TextInput
            placeholder="Search"
            placeholderTextColor={'rgba(255, 255, 255, 0.4)'}
            color="#ffffff"
            onChangeText={text => onChangeSearchText(text)}
            value={searchText}
            style={{
               color: '#ffffff',
               paddingLeft: 16,
               backgroundColor: '#00000000',
               borderWidth: 0,
               width: isLandscapemode ? 200 : '75%',
               marginEnd: !isWindows ? 10 : 0,
               height: 40,
               paddingVertical: isWindows || isMacOS ? 11 : 6,
               fontFamily: FONT_FAMILY_REGULAR,
               fontWeight: '500',
               fontSize: 14,
               ...Platform.select({
                  web: {
                     padding: 6,
                     maxWidth: '100%',
                     width: isLandscapemode ? 200 : '100%',
                  },
               }),
            }}
            onFocus={searchHandleFocus}
            onBlur={searchHandleBlur}
         />
         {Platform.OS != 'windows' && (
            <TouchableOpacity
               onPress={() => {
                  props.onClearText();
                  setSearchText('');
               }}>
               <Image
                  source={require('../../assets/cross.png')}
                  style={{
                     width: imageSize,
                     height: searchText.length > 0 ? imageSize : 0,
                     marginRight: 15,
                     opacity: 0.7,
                  }}
               />
            </TouchableOpacity>
         )}
         <View
            style={{
               backgroundColor: primaryColor500,
               justifyContent: 'center',
               alignSelf: 'stretch',
               width: 40,
               height: 40,
               ...Platform.select({
                  web: {
                     width: 40,
                     height: 40,
                     borderTopRightRadius: 4,
                     borderBottomRightRadius: 4,
                  },
                  android: {
                     width: isLandscapemode ? 47 : 45,
                     height: isLandscapemode ? 47 : 45,
                     borderTopRightRadius: mobRadius,
                     borderBottomRightRadius: mobRadius,
                  },
                  ios: {
                     width: isLandscapemode ? 47 : 45,
                     height: isLandscapemode ? 47 : 45,
                     borderTopRightRadius: mobRadius,
                     borderBottomRightRadius: mobRadius,
                  },
                  macos: {
                     width: 40,
                     height: 40,
                     borderTopRightRadius: 4,
                     borderBottomRightRadius: 4,
                  },
               }),
            }}>
            <Image
               source={require('../../assets/search.png')}
               style={{width: 18, height: 18, alignSelf: 'center'}}
            />
         </View>
      </View>
   );
};

export default SearchView;
